import { IMultiSelectOptionList } from '~/helpers/interfaces';

export const flyerTemplateOptions: IMultiSelectOptionList[] = [
  {
    value: 'includeInstagram',
    text: 'send instagram image?',
    isSelected: false
  }
];

export const pdfEmailContent = `Hi Team,<br>
Please see the <strong>attached custom event flyer</strong> for your upcoming event posted in Cobu. This version includes the Cobu QR code and a clear call to action to "RSVP on Cobu."<br>
<strong>What to do with this flyer:</strong>
• Print and post in high-visibility areas: elevators, mail rooms, amenity spaces, entry doors.
• If you send an e-blast, attach this flyer.<br>
<strong>Using this version helps:</strong>
• Drive accurate RSVPs in one place
• Increase visibility with residents not yet on Cobu
• Grow adoption while promoting your event<br>
If you create your own flyers, please be sure to include the QR code and "RSVP on Cobu" messaging. (You can toggle the flyer selection off when adding your event in Cobu.)<br>
Please let us know if you have any questions - we're happy to help!<br>
– Your Cobu Team`;

export const pdfWithInstaEmailContent = `Hi Team,<br>
Please see the <strong>attached custom event flyer</strong> for your upcoming event posted in Cobu. This version includes the Cobu QR code and a clear call to action to "RSVP on Cobu."<br>
<strong>What to do with this flyer:</strong>
• Print and post in high-visibility areas: elevators, mail rooms, amenity spaces, entry doors.
• If you send an e-blast, attach this flyer.<br>
<strong>Using this version helps:</strong>
• Drive accurate RSVPs in one place
• Increase visibility with residents not yet on Cobu
• Grow adoption while promoting your event<br>
We have also added in an image that you can use on <strong>Instagram</strong>  if you are interested.
<br>
If you create your own flyers, please be sure to include the QR code and "RSVP on Cobu" messaging. (You can toggle the flyer selection off when adding your event in Cobu.)<br>
Please let us know if you have any questions - we're happy to help!<br>
– Your Cobu Team`;
